import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import '@/components/globals/'
//import VueCurrencyInput from 'vue-currency-input'
import IdleVue from 'idle-vue';
import VueMask from 'v-mask';
import Login from '@/layouts/Login.vue';
import Default from '@/layouts/Default.vue';
import Noauth from '@/layouts/NoAuth.vue';
import Robo from '@/layouts/Robo.vue';
//import VirtualList from "vue3-virtual-scroll-list";

const eventsHub = new Vue();
Vue.use(VueMask)

//Vue.use(VirtualList)
//Vue.use(VueCurrencyInput)

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 599000, 
  startAtIdle: false,
  idleVue_onActive:()=>{
   
  },
  idleVue_onIdle:()=>{
   
    this.$store.dispatch("logout");
  }
});
Vue.component('login-layout', Login);
Vue.component('default-layout', Default);
Vue.component('noauth-layout', Noauth);
Vue.component('robo-layout', Robo);

Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.config.compilerOptions.isCustomElement = tag => tag === 'progress-bar'
new Vue({
	router,
	store,
	render: h => h(App),
  
}).$mount('#app');